import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Loader2, Megaphone, Instagram, CalendarDays } from "lucide-react";
import { MarketingAds } from "@/components/marketing/MarketingAds";
import { MarketingProfiles } from "@/components/marketing/MarketingProfiles";
import { MarketingCalendar } from "@/components/marketing/MarketingCalendar";

const TABS = [
  ["ads", "Sponsorizzate", Megaphone],
  ["profiles", "Profili social", Instagram],
  ["calendar", "Calendario 4 settimane", CalendarDays],
];

const Empty = ({ text }) => <p className="text-sm text-muted-foreground" data-testid="marketing-empty">{text}</p>;

export const MarketingInsights = () => {
  const [tab, setTab] = useState("ads");
  const { data, isLoading } = useQuery({ queryKey: ["marketing"], queryFn: async () => (await api.get("/sales/marketing")).data });
  return (
    <Card className="mt-6 p-6" data-testid="marketing-insights">
      <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-lg font-semibold">Analisi marketing</h3>
          <p className="text-xs text-muted-foreground">Calcolata ora dai dati di Meta e Shopify: sponsorizzate, profili e piano contenuti.</p>
        </div>
        <div className="flex flex-wrap gap-1">
          {TABS.map(([k, l, Icon]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`marketing-tab-${k}`}
              className={`flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs transition-colors ${tab === k ? "border-primary bg-primary text-primary-foreground" : "border-border/60 hover:bg-secondary/50"}`}>
              <Icon className="h-3.5 w-3.5" />{l}</button>
          ))}
        </div>
      </div>
      {isLoading || !data ? <Loader2 className="h-5 w-5 animate-spin text-primary" /> : (
        <>
          {tab === "ads" && (data.ads ? <MarketingAds ads={data.ads} /> : <Empty text="Nessun dato delle sponsorizzate: collega Meta dal pannello Social." />)}
          {tab === "profiles" && (data.profiles ? <MarketingProfiles p={data.profiles} /> : <Empty text="Nessun post sincronizzato: collega Meta dal pannello Social." />)}
          {tab === "calendar" && (data.calendar ? <MarketingCalendar c={data.calendar} /> : <Empty text="Nessun prodotto della stagione in corso." />)}
        </>
      )}
    </Card>
  );
};
